import Recorder from 'recorder-js'

const defaultState = () => {
  return {
    recorder: null,
    isRecording: false,
    recordingTime: 0,
    timer: null
  }
}

const state = defaultState()

const getters = {
  
}

const mutations = {
  
}

const actions = {
  startRecording({ commit, state }) {
    navigator.mediaDevices.getUserMedia({audio: true}).then(stream => {
      state.recorder = new Recorder(new (window.AudioContext || window.webkitAudioContext)())
      state.recorder.init(stream)
      state.recorder.start().then(() => {
        state.isRecording = true
        state.timer = setInterval(() => {
          state.recordingTime += 0.05
        }, 50)
      })
    }).catch(e => {
      if(e.toString().includes('Requested device not found')) {
        vm.$root.$emit('alert', 'error', '找不到麥克風')
      }
      else {
        vm.$root.$emit('alert', 'error', '請開啟麥克風權限')
      }
    })
  },
  stopRecording({ commit, state }, callback) {
    if(!state.recorder) {
      return
    }
    state.recorder.stop().then(({blob, buffer}) => {
      state.isRecording = false
      clearInterval(state.timer)
      state.recordingTime = 0
      callback ? callback(blob) : null
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}